<template>
    <div class="wrapper">
        <div class="left">
            <div>
                <div class="tab" @click="changeTab('Orderlist')" :class="{ 'active': currentTab === 'Orderlist' }"><i
                        class="el-icon-tickets"></i></div>
                <div class="tab" @click="changeTab('Cart')" :class="{ 'active': currentTab === 'Cart' }"><i
                        class="el-icon-shopping-cart-2"></i></div>
                <div class="tab" :class="{ 'active': currentTab === 2 }"><i class="el-icon-service"></i></div>
                <div class="tab" :class="{ 'active': currentTab === 3 }"><i class="el-icon-postcard"></i></div>
                <div class="tab" @click="changeTab('Profile')" :class="{ 'active': currentTab === 'Profile' }"><i
                        class="el-icon-user"></i></div>
                <div class="tab" @click="open()"><img src="@/assets/imgs/uploads/mobile/Vector2.png"
                        style="width: 5.867vw;height: 5.067vw;" alt=""></div>
            </div>
        </div>
        <div class="right">
            <router-view></router-view>
        </div>
    </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
    data() {
        return {
            currentTab: 'Orderlist',
            visible: false,// 是否退出登录
        }
    },
    created() {
        this.changeTab('Orderlist')
    },

    beforeRouteEnter(to, from, next) {
        // 在进入路由前调用，此时组件实例还未被创建
        next(vm => {
            // 通过 `vm` 访问组件实例
            vm.currentTab = "Orderlist";
        });
    },
    methods: {
        ...mapActions(["setUser"]),
        changeTab(tab) {
            this.currentTab = tab;
            this.$router.push({ name: tab });
        },
        logout() {
            this.visible = false;
            // 清空本地登录信息
            localStorage.setItem("user", "");
            // 清空vuex登录信息
            this.setUser("");
            this.notifySucceed(this.$t('prompt.hint3'));
        },
        open() {
            this.$confirm('Want to log out?', '', {
                confirmButtonText: 'OK',
                cancelButtonText: 'Cancel',
                type: 'warning'
            }).then(() => {
                this.logout()
            }).catch(() => {
            });
        }
    },
}
</script>

<style scoped>
.wrapper {
    font-size: 16px;
    border-top: 1px solid #c7c7c7;
    margin-top: -1px;
    display: flex;
}

.left {
    width: 79px;
    flex-shrink: 0;
    box-shadow: 10px 0 10px -5px rgba(0, 0, 0, 0.1);
    height: auto;
}
.right{
    width: 296px;
}
.tab {
    height: 79px;
    font-size: 25px;
    text-align: center;
    line-height: 79px;
    color: #959595;
    font-weight: bold;
}

.title {
    margin-left: 10px;
    font-size: 16px;
}

.active {
    color: #FFF;
    background-color: #CA141D;
}

::v-deep .el-button.el-button--default.el-button--small {
    font-size: 16px;
}
</style>